import { config } from "../../config";
import { ToastProgrammatic as Toast } from 'buefy';

export const namespaced = true;

export const state = {
    appVersion: config.appVersion,
    currentAppVersion: null,
    token: "",
}

export const mutations = {
    SET_CURRENT_APP_VERSION(state, payload){
        console.log('set current app version mutation: ' + payload);
        state.currentAppVersion = payload;
    },
    ADD_TOKEN(state, payload){
        state.token = payload;
    },
    ALTER_SESSION(state, payload){
        state.sessionKey = payload;
    },
}

export const actions = {
    addToken(context, payload){
        context.commit('ADD_TOKEN', payload);
    },
    alterSession(context){
        context.commit('ALTER_SESSION');
    },
}

export const getters = {
    appVersion(state){
        return state.appVersion;
    },
    currentAppVersion(state){
        return state.currentAppVersion;
    },
    appVersionsMatch(getters){
        return getters.appVersion == getters.currentAppVersion;
    },
    getActiveUser(state, getters, rootState){
        return rootState.travellersAndTrips.profile;
    },
}